// extracted by mini-css-extract-plugin
export default {"root":"ListingTagList_root__LNskB","tag":"ListingTagList_tag__B-ap5 textXSmall","disabled":"ListingTagList_disabled__PrOWc"};